import React from "react";
import "./RecipientTicket.css";

class RecipientTicket extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.handleRequest = this.handleRequest.bind(this);
    }

    async handleRequest(event) {
        this.props.addRequest(event.target.id);
    }

    render() {
        return (
            <div className="ticket-container">
                <div className="left-ticket">
                    <h3>{this.props.ticket.ticket_date} - {this.props.ticket.ticket_team}'s Tickets</h3>
                    <div className="seat-info">
                        <p>Section: {this.props.ticket.seat_section}</p>
                        <p>Row: {this.props.ticket.seat_row}</p>
                        <p>Seats: {this.props.ticket.seat_numbers}</p>
                    </div>
                </div>
                <p className="request-button" id={this.props.ticket.id} onClick={this.handleRequest}>REQUEST</p>
            </div>
        );
    }
}

export default RecipientTicket;